/**
 * Types chat in-game (cf wiki §31 + KSAdmin ChatController).
 * Aligne avec Siclop.KSAdmin.BusinessModels.Chat.* + Infrastructure.Enumerations.Chat*.
 */

export type ChatRoomType = 'Direct' | 'Entity' | 'Group';
export type ChatMessageType = 'Text' | 'File' | 'System';
export type ChatEntityType = 'Quote' | 'Invoice' | 'Project' | 'Customer' | 'Supplier' | string;

export interface ChatParticipantModel {
  id: number;
  chatRoomId: number;
  userId: number;
  userName: string;
  userDisplayName?: string | null;
  joinedAt: string;
  leftAt?: string | null;
  lastReadAt?: string | null;
  isActive: boolean;
  isOnline: boolean;
}

export interface ChatMessageReadReceiptModel {
  id: number;
  messageId: number;
  userId: number;
  userName: string;
  readAt: string;
}

export interface ChatMessageModel {
  id: number;
  chatRoomId: number;
  senderId: number;
  senderName: string;
  senderDisplayName?: string | null;
  content: string;
  messageType: ChatMessageType;
  sentAt: string;
  editedAt?: string | null;
  isDeleted: boolean;
  replyToMessageId?: number | null;
  replyToMessage?: ChatMessageModel | null;
  fileId?: number | null;
  fileName?: string | null;
  readReceipts: ChatMessageReadReceiptModel[];
  isRead: boolean;
}

export interface ChatRoomModel {
  id: number;
  name?: string | null;
  roomType: ChatRoomType;
  entityType?: ChatEntityType | null;
  entityId?: number | null;
  createdById: number;
  isArchived: boolean;
  participants: ChatParticipantModel[];
  messages: ChatMessageModel[];
  /** Nom affichable cote serveur : nom de groupe, ou pseudo de l'autre pour un DM. */
  displayName: string;
  lastMessage?: ChatMessageModel | null;
  unreadCount: number;
}

export interface SendMessagePayload {
  chatRoomId: number;
  content: string;
  messageType?: ChatMessageType;
  replyToMessageId?: number | null;
  fileId?: number | null;
  fileName?: string | null;
}

/** Format de la date pour l'affichage relatif. */
export function formatRelativeDate(iso: string): string {
  const d = new Date(iso);
  const now = new Date();
  const diff = Math.floor((now.getTime() - d.getTime()) / 1000);
  if (diff < 60) return 'a l\'instant';
  if (diff < 3600) return `il y a ${Math.floor(diff / 60)} min`;
  if (diff < 86400) return `il y a ${Math.floor(diff / 3600)} h`;
  if (diff < 86400 * 7) return `il y a ${Math.floor(diff / 86400)} j`;
  return d.toLocaleDateString('fr-FR');
}

export function roomTypeIcon(t: ChatRoomType): string {
  switch (t) {
    case 'Direct': return 'User';
    case 'Entity': return 'Document';
    case 'Group':  return 'UserFilled';
    default:       return 'ChatDotRound';
  }
}
